import { create } from 'zustand'

export type InvitationStatus =
  | 'PENDING'
  | 'ACCEPTED'
  | 'REJECTED'
  | 'EXPIRED'
  | 'DECLINED'

export interface IDataInvitation {
  inviteId: string
  email: string
  agencyId: string
  agencyName: string
  isOnDb: boolean
  expiresAt: number
  logo: string | null
  status: InvitationStatus
  requestType: 'REQUEST' | 'INVITE'
  statusAccepted?: boolean
  senderUser?: {
    id: string
    photo: string | null
    firstName: string | null
    lastName: string | null
    newRoles?: string[]
  }
}

interface ModalBrokerInvitationState {
  isOpen: boolean
  setIsOpen: ({
    isOpen,
    status,
    invitationData
  }: {
    isOpen: boolean
    status: InvitationStatus | undefined
    invitationData: IDataInvitation | undefined
    brokerAgencyRequestExists: boolean | undefined
  }) => void
  setStatus?: (status: InvitationStatus) => void
  brokerAgencyRequestExists?: boolean | undefined
  invitationData?: IDataInvitation | undefined
  status?: InvitationStatus | undefined
}

const initialState = {
  isOpen: false,
  status: undefined,
  brokerAgencyRequestExists: undefined,
  invitationData: undefined
}

export const useModalBrokerInvitationStore =
  create<ModalBrokerInvitationState>()((set) => ({
    ...initialState,
    setIsOpen: ({
      isOpen,
      status,
      invitationData,
      brokerAgencyRequestExists
    }) => set({ isOpen, status, invitationData, brokerAgencyRequestExists }),
    setStatus: (status) => set({ status })
  }))
